import { useRequiredParams } from '@pba/react-router';
import { GivingDetail, GivingDetailLayout, GivingHeader } from 'features/givings';
import { useGivingNavigation } from '../../hooks';
import { useGiveTransactionParams } from '../hooks';

const PageGivingDetail = () => {
  const { givingId } = useRequiredParams<{ givingId: string }>();
  const { paymentRedirectUrl } = useGivingNavigation();
  const giveTransaction = useGiveTransactionParams();

  return (
    <GivingDetailLayout
      header={({ givingContentObject }) => <GivingHeader givingContentObject={givingContentObject} />}
      id={givingId}
    >
      {({ givingContentObject }) => (
        <GivingDetail
          giveTransaction={giveTransaction}
          givingContentObject={givingContentObject}
          paymentRedirectUrl={paymentRedirectUrl}
        />
      )}
    </GivingDetailLayout>
  );
};

export default PageGivingDetail;
